<template>
  <div class="crossreference-box">
    <!-- 对照录入 -->
    <div class="crossreference-tabs">
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane label="完整病程" name="first">
        </el-tab-pane>
        <el-tab-pane label="当前症状" name="second">
        </el-tab-pane>
        <el-tab-pane label="患者提交症状" name="third">
        </el-tab-pane>
      </el-tabs>
      <span v-if="patientSymptomData.length > 0" class="red-tag"></span>
      <el-button v-show="activeName == 'first'" style="height:32px" size="small" @click="addDiseaseRecord">＋ 添加
      </el-button>
    </div>
    <!-- crossReference  -->
    <div v-show="activeName == 'first'" style="height:calc(100% - 50px)" class="medicalRecordFolder">
      <div class="type-title">
        <div class="tab-box">
          <div :class="curIndex == 1?'checked':''" @click="changeSymp(1)">症状</div>
          <div :class="curIndex == 2?'checked':''" @click="changeSymp(2)">生化指标</div>
        </div>
        <p @click="showPushRecord" v-if="curIndex == 1">问询推送记录 <i class="el-icon-arrow-right"></i></p>
      </div>
      <template v-if="curIndex == 1">
        <div class="crossReference-reminder-search search-line">
          <div style="flex:1.5">
            <el-date-picker size="mini" style="width:100%" v-model="searchQueryObj.searchQueryTime" type="daterange"
              :picker-options="pickerOptions0" range-separator="至" value-format="yyyy-MM-dd" start-placeholder="开始日期"
              end-placeholder="结束日期" @input="changeQueryTime">
            </el-date-picker>
          </div>
          <div class="file-name" style="flex:1">
            <!-- 或操作人姓名 -->
            <el-input placeholder="请输入症状名称" prefix-icon="el-icon-search" v-model="searchQueryObj.name" size="mini"
              clearable>
            </el-input>
          </div>
          <el-button type="primary" size="mini" @click="getPageCourse(1)">搜索</el-button>
        </div>
        <div id="all-data" v-if="allCourseData" style="height: calc(100% - 128px);font-size: 12px;overflow:auto">
          <div class="record-folder-content" v-for="(it, key, ind) in allCourseData" :key="ind">
            <div class="all-course">
              <div class="record-folder-time">
                <span class="circle-dot"></span>
                <!-- 字标红或者标蓝色后点击修改打开弹框之后再关闭弹框字体颜色恢复原状 -->
                <!-- <span :class="`time ${it.operateName}`"><span v-if="it.dateName">{{ it.dateName }}:</span>
                  {{ it.courseTime }}</span> -->
                <!-- <span class="source">
                  <img src="@/assets/images/source_icon.png" alt="">
                  <span>来源：患者端-症状记录</span>
                </span> -->
              </div>
            </div>
            <ul class="patient-line-symptom patient-line-symptom-all">
              <li style="display:block;width:100%">
                <div class="symptom-row" v-for="(item,index) in it.records" :key="index">
                  <div class="symptom-row-title">
                    <!-- 字标红或者标蓝色后点击修改打开弹框之后再关闭弹框字体颜色恢复原状 -->
                    <span :class="`time${item.operateName ? ' ' + item.operateName : ''}`">
                      <span v-if="it.dateName && it.dateName !== 'null'">{{ it.dateName }}:</span>
                      {{ it.courseTime }}</span>
                    <!-- <span class="source">
                      <img src="@/assets/images/source_icon.png" alt="">
                      <span>来源：患者端-症状记录</span>
                    </span> -->
                    <div v-if="item.courseTime" class="courseInfo-row">
                      <span class="update-btn" v-if="loginUserId == item.createUserId" @click="updateCourse(item)"><i
                          class="el-icon-edit"></i>修改</span>
                      <span class="delete-btn" v-if="loginUserId == item.createUserId" @click="deleteCourse(item)"><i
                          class="el-icon-delete"></i>移除</span>
                    </div>
                  </div>
                  <div style="display:flex;flex-wrap:wrap;margin-bottom:8px">
                    <div v-for="(v,k) in item.patientSymptomVOList" :key="k"
                      style="margin-right:16px;margin-bottom:5px">
                      <span class="symptom-name">{{v.name}}<span v-if="v.levelName">-{{ v.levelName }}</span></span>
                      <el-tooltip v-if="v.ended" placement="right" v-model="v.disabledTip">
                        <div slot="content">
                          {{optionUser}}结束 结束时间：{{v.endTime}}
                        </div>
                        <span class="end-status" @mouseenter="clickOptionUser(v)">已结束</span>
                      </el-tooltip>
                      <el-tooltip v-else placement="right" v-model="v.disabledTip">
                        <div slot="content">
                          {{optionUser}}添加
                        </div>
                        <span class="ing-status" @mouseenter="clickOptionUser(v)">进行中</span>
                      </el-tooltip>
                    </div>
                  </div>
                  <div v-if="item.patientSymptomVOListString">{{ item.patientSymptomVOListString }}</div>
                  <div v-if="item.checkInfoString">{{item.checkInfoString}}</div>
                  <div v-if="item.inspectionInfoString">{{item.inspectionInfoString}}</div>
                  <div v-if="item.medicationStatus">{{item.medicationStatus}}</div>
                  <div v-if="item.patientInformation">{{item.patientInformation}}</div>
                  <div v-if="item.therapistEvaluation">{{item.therapistEvaluation}}</div>
                </div>
              </li>
            </ul>
          </div>
          <p v-if="!loading"
            style="font-size: 12px; color: rgb(204, 204, 204); text-align: center; margin-top: 50px; margin-bottom: 30px;">
            加载中...</p>
          <p v-else
            style="font-size: 12px; color: rgb(204, 204, 204); text-align: center; margin-top: 50px; margin-bottom: 30px;">
            人家是有底线的~</p>
        </div>
      </template>
      <!-- 生化指标记录 -->
      <template v-else>
        <div class="crossReference-reminder-search search-line">
          <div style="flex:1.5">
            <el-date-picker size="mini" style="width:100%" v-model="hisToryObj.time" type="daterange"
              range-separator="至" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"
              @input="changeQueryTime">
            </el-date-picker>
          </div>
          <div class="file-name" style="flex:1">
            <el-input placeholder="请输入指标项名称" prefix-icon="el-icon-search" v-model="hisToryObj.nameLike" size="mini"
              clearable>
            </el-input>
          </div>
          <el-button type="primary" size="mini" @click="getAnomalyHistory(1)">搜索</el-button>
        </div>
        <div id="all-data" v-if="allCourseData" style="height: calc(100% - 128px);font-size: 12px;overflow:auto">
          <div class="record-folder-content" v-for="(item, index) in anomalyData" :key="index">
            <div class="record-folder-time">
              <span class="circle-dot"></span>
              <span class="time">{{item.eventDate}}</span>
            </div>
            <ul class="patient-line-symptom anomaly">
              <li style="display:block;width:100%" v-for="(sec,index) in item.ocrAnomalyIndexList" :key="index">
                <div class="symptom-row" v-for="(child,i) in sec.anomalyIndex" :key="i">
                  <div class="symptom-result">
                    <p :title="child.focusFieldName">{{child.focusFieldName}}</p>
                    <p>{{child.inputValue}}{{child.doseUnit}}</p>
                    <div class="result-type" :class='child.exceptionRecord !="3"?"abnormal":""'>
                      <template v-if="child.exceptionRecord !='3'">
                        <i class="el-icon-warning"></i>
                        <span>异常</span>
                      </template>
                      <template v-else>
                        <i class="el-icon-success"></i>
                        <span>正常</span>
                      </template>
                    </div>
                  </div>
                  <div class="reuslt-range"> 异常范围：{{child.abnormalRange}}{{child.doseUnit}}</div>
                </div>
              </li>
            </ul>
          </div>
          <p v-if="!loading"
            style="font-size: 12px; color: rgb(204, 204, 204); text-align: center; margin-top: 50px; margin-bottom: 30px;">
            加载中...</p>
          <p v-else
            style="font-size: 12px; color: rgb(204, 204, 204); text-align: center; margin-top: 30px; margin-bottom: 30px;">
            人家是有底线的~</p>
        </div>
      </template>
      <el-drawer title="问询推送记录" :visible.sync="drawerRecord" class="push-title">
        <el-scrollbar :style="{'height':screenHeight+'px'}" id="resultScroll" v-loading='hisLoading' ref="myScrollbar">
          <template v-if="recordList.length>0">
            <div class="record-list" v-for="(item,index) in recordList" :key="index">
              <div class="record-title">
                <div class="date-icon">
                  <img src="@/assets/images/date.png" alt="">
                  <span>问询日期：{{item.pushTime}}</span>
                </div>
                <p>症状提交第{{item.pushTmeNode}}天</p>
              </div>
              <div class="symptom-item-box">
                <template>
                  <div class="symptom-item">
                    <p>患者已{{item.pushType == 'RELIEF'?'改善':'消失'}}的症状</p>
                    <div class="symptom-flex">
                      <div v-for="(child,i) in item.pushSymptoms" :key="i">
                        <img v-if="child.isCheck" src="@/assets/images/checked.png" alt="">
                        <p v-else class="no-checked-mark"></p>
                        {{child.symptomName}}
                      </div>
                      <div>
                        <img v-if="item.isNoCheck" src="@/assets/images/checked.png" alt="">
                        <p v-else class="no-checked-mark"></p>
                        均未{{item.pushType == 'RELIEF'?'改善':'消失'}}
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
          <div v-else class="empty-img" :style="{'height':screenHeight+'px'}">
            <img src="@/assets/images/empty.png">
          </div>
          <div class="no-data" v-if="showNoData&& recordList.length!=0">人家是有底线的~</div>
        </el-scrollbar>

      </el-drawer>
    </div>
    <!-- 当前症状 -->
    <!-- class="crossReference" style="height:calc(100% - 50px)" -->
    <div v-show="activeName == 'second'">
      <div class="symptom-table-data" style="margin-top:24px">
        <el-table :data="nowSymptomData"
          :header-cell-style="{textAlign: 'center',color: '#333333',fontSize: '14px', fontWeight: 'bold',backgroundColor: '#FAFAFA'}"
          tooltip-effect="dark" ref="multipleTable" fit highlight-current-row>
          <el-table-column align="center" type="index" label="序号"></el-table-column>
          <el-table-column align="center" prop="name" label="症状名称" show-overflow-tooltip></el-table-column>
          <el-table-column align="center" prop="levelName" label="症状程度" show-overflow-tooltip></el-table-column>
          <el-table-column align="center" prop="forADay" label="持续时间" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.forADay}}天</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="120">
            <template slot-scope="scope">
              <el-popover v-model="scope.row.editVisible" placement="left" width="450" @show="endRemoveTime=''"
                popper-class="remove-pop">
                <!-- <p class="remove-tips">编辑症状</p> -->
                <div class="remove-tips" style="display:flex">
                  <span style="line-height:28px; width: 120px;text-align:right">症状分级：</span>
                  <el-select v-model="levelId" placeholder="请选择" size="mini">
                    <el-option v-for="item in symptomGradingOption" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <div style="text-align: center">
                  <el-button size="mini" @click="cancelSeverity(scope.row)">取消</el-button>
                  <el-button type="primary" size="mini" :loading="editSeverityLoading"
                    @click="editSeverity(scope.row)">确认</el-button>
                </div>
                <el-button type="text" size="medium" slot="reference" v-if="scope.row.editFlag"
                  style="margin-right: 10px" @click="getSymptomLevelList(scope.row)">编辑</el-button>
              </el-popover>
              <!-- <el-popconfirm
                  popper-class="symptom-table-pop"
                  :title="`确定移除“${scope.row.name}”症状吗？`"
                  cancel-button-type="Primary"
                  @confirm="confirmRemove(scope.row)"
                >
                  <el-button type="text" size="medium" slot="reference">移除</el-button>
                </el-popconfirm> -->

              <el-popover v-model="scope.row.removeVisible" placement="left" width="360" @show="endRemoveTime=''"
                popper-class="remove-pop">
                <p class="remove-tips"><i class="el-icon-warning" style="color:#FAAD14"></i>确定移除“{{scope.row.name}}”症状吗？
                </p>
                <div class="remove-tips">
                  <span>症状开始时间：</span>
                  <span>{{scope.row.startTime}}</span>
                </div>
                <div class="remove-tips" style="display:flex">
                  <span style="line-height:32px">症状结束时间：</span>
                  <el-date-picker type="date" size="small" placeholder="选择日期" format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd" v-model="endRemoveTime" :picker-options="pickerOptions0"></el-date-picker>
                </div>
                <div style="text-align: center">
                  <el-button size="mini" @click="scope.row.removeVisible = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="confirmRemove(scope.row)">确定</el-button>
                </div>
                <el-button type="text" size="medium" slot="reference">移除</el-button>
              </el-popover>

              <!-- <el-popover placement="top-start" width="200" popper-class="delete-commit" v-model="item.visible">
                  <div class="content">
                    <i class="el-icon-warning" style="color: #FAAD14;font-size: 16px;margin-right: 8px"></i>
                    <span>确定移除“{{scope.row.name}}”症状吗？</span>
                  </div>
                  <div class="delete-btn-box" style="margin-top: 10px;text-align: center;">
                    <el-button size="mini" @click="item.visible = false">取 消</el-button>
                    <el-button type="primary" @click="confirmRemove(scope.row)" size="mini">确 定</el-button>
                  </div>
                  <div slot="reference" class="delete">移除</div>
                </el-popover> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 患者提交症状 -->
    <!-- class="crossReference" -->
    <div v-show="activeName == 'third'">
      <!-- <div class="crossReference-reminder-search search-line">
        <div style="width:300px">
          <el-date-picker size="mini" style="width:100%" v-model="searchQueryObj.searchQueryTime" type="daterange" :picker-options="pickerOptions0"
            range-separator="至" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <el-button type="primary" size="mini" @click="getPatientSavePage">搜索</el-button>
      </div> -->
      <div class="symptom-table-data" style="margin-top:24px">
        <el-table :data="patientSymptomData"
          :header-cell-style="{textAlign: 'center',color: '#333333',fontSize: '14px', fontWeight: 'bold',backgroundColor: '#FAFAFA'}"
          tooltip-effect="dark" ref="multipleTable" fit highlight-current-row>
          <el-table-column align="center" type="index" label="序号"></el-table-column>
          <el-table-column align="center" prop="createTime" label="添加时间" show-overflow-tooltip></el-table-column>
          <el-table-column align="center" prop="name" label="症状名称" show-overflow-tooltip></el-table-column>
          <el-table-column align="center" label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" size="medium" @click="handleAdd(scope.row)">添加</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="footer-pagination">
      <el-pagination v-show="activeName == 'second' || activeName == 'third'" background :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
    <!-- 添加病程 -->
    <AddCourseOfDisease v-if="showAddRecord" :showAddRecord.sync="showAddRecord" :selectRecordItem="selectRecordItem"
      @getPageCourse="getPageCourse"></AddCourseOfDisease>
    <!-- 添加/关联症状 -->
    <AddSymptom v-if="showAddStatus" :showAddStatus.sync="showAddStatus" @getPatientSavePage="getPatientSavePage"
      :selectRow="selectRow"></AddSymptom>
  </div>
</template>

<script>
import local from "@/utils/local.js";
import moment from "moment";
import {
  pageCourseNew,
  anomalyHistory,
  pageSymptom,
  patientSavePage,
  endedSymptomById,
  editSymptomSeverity,
  getUserInfo,
  symptomsRecordsPage,
  deleteCourseSymptom,
  pageSymptomLevelList,
  getArchiveDiseaseAndTherapyStage,
} from "@/api/addCourseOfDisease";
export default {
  name: "SymptomRecord",
  props: {
    // patientFilesItemV2VO: {
    //   type: Object
    // },
    schemeNameList: {
      type: Array
    }
  },
  components: {
    AddCourseOfDisease: () => import("./component/AddCourseOfDisease.vue"),
    AddSymptom: () => import("./component/AddSymptom.vue")
  },
  data() {
    return {
      showNoData: false,
      curIndex: 1,
      hisLoading: false,
      screenHeight: document.body.clientHeight - 75,
      drawerRecord: false,
      recordList: [],
      loginUserId: local.get("userid"),
      removeVisible: false,
      endRemoveTime: "",
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      current: 1,
      size: 20,
      selectRow: {},
      currentPage: 1,
      pageSize: 10,
      totalNum: 0,
      showAddStatus: false,

      showAddRecord: false,
      nowSymptomData: [],
      patientSymptomData: [],
      allCourseData: [],
      anomalyData: [],
      searchQueryObj: {
        searchQueryTime: [],
        name: ""
        // current: 1,
        // size: 10
      },
      hisToryObj: {
        time: [],
        nameLike: ""
      },
      activeName: "first",
      loading: false,
      optionUser: "",
      selectRecordItem: {},
      symptomCurrent: 1,
      symptoTotal: 0,
      // disabledTip: false
      symptomGradingOption: [], // 症状程度
      levelId: "",
      diseaseAndTherapyStage: {}, // 获取病种及治疗阶段
      editSeverityLoading: false
    };
  },
  watch: {
    "$store.state.patientInfo.patientId": {
      async handler(newVal, oldVal) {
        this.activeName = "first";
        this.current = 1;
        this.getPageCourse();
        this.getPatientSavePage();
      },
      deep: true
    }
  },
  created() {
    this.current = 1;
    this.getPageCourse();
    this.getPatientSavePage();
    this.getDiseaseIdTherapyStage();
  },
  mounted() {
    window.addEventListener("scroll", this.lazyLoading, true);
  },
  methods: {
    showPushRecord() {
      let that = this;
      that.drawerRecord = true;
      // 监听滚动事件
      that.$nextTick(() => {
        // if(this.recordList.length>0){
        document
          .getElementById("resultScroll")
          .addEventListener("scroll", that.handleScroll, true);
        // }
      });
      this.getSymptomsRecordsPage(1);
    },

    getSymptomsRecordsPage(flag) {
      this.hisLoading = true;
      if (flag == 1) {
        this.symptomCurrent = 1;
        this.recordList = [];
      }
      let params = {
        current: this.symptomCurrent,
        size: 10,
        patientId: this.$store.state.patientInfo.patientId
      };
      symptomsRecordsPage(params)
        .then(res => {
          if (res.code == 0) {
            this.hisLoading = false;
            this.recordList = this.recordList.concat(res.data.records);
            if (flag == 1) {
              this.symptoTotal = res.data.total;
            }
            if (this.recordList.length == this.symptoTotal) {
              this.showNoData = true;
            } else {
              this.showNoData = false;
            }
          }
        })
        .catch(err => {
          this.hisLoading = false;
        });
    },
    handleScroll() {
      let that = this;
      let sh = that.$refs["myScrollbar"].$refs["wrap"].scrollHeight; // 滚动条高度
      let st = that.$refs["myScrollbar"].$refs["wrap"].scrollTop; // 滚动条距离顶部的距离
      let ch = that.$refs["myScrollbar"].$refs["wrap"].clientHeight; // 滚动条外容器的高度
      if (st + ch >= sh) {
        that.symptomCurrent += 1;
        if (that.recordList.length < that.symptoTotal) {
          that.getSymptomsRecordsPage();
        }
      }
    },
    changeSymp(val) {
      this.curIndex = val;
      this.current = 1;
      this.loading = false;
      if (val == 1) {
        this.getPageCourse(1);
      } else {
        this.getAnomalyHistory(1);
      }
    },
    async updateCourse(item) {
      // 调用接口更新状态
      // item.operateName = "";
      this.showAddRecord = true;
      this.selectRecordItem = item;
    },
    deleteCourse(item) {
      this.$confirm(
        "确认要移除吗，移除后病程内的患者症状及患者提醒，均会同步删除",
        "提示",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(async () => {
          let { code, data } = await deleteCourseSymptom(item.id);
          if (code === 0) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getPageCourse();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    async lazyLoading(e) {
      if (this.loading || this.curIndex == 2) {
        return;
      }
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = e.target.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight = e.target.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight = e.target.scrollHeight;
      //滚动条到底部的条件
      if (scrollTop + windowHeight == scrollHeight) {
        // //写后台加载数据的函数
        this.current++;
        await this.getPageCourse();
      }
    },
    async clickOptionUser(v) {
      v.disabledTip = !v.disabledTip;
      if (!v.disabledTip) {
        return;
      }

      let res = await getUserInfo({
        userId: v.ended ? v.updateUserId : v.createUserId
      });
      if (res.code == 0) {
        this.optionUser = res.data.realName;
      }
      // this.$forceUpdate()
    },
    async confirmRemove(row) {
      if (
        new Date(this.endRemoveTime).getTime() <
        new Date(row.startTime).getTime()
      ) {
        this.$message.error("结束日期不能早于开始日期");
        return;
      }
      let res = await endedSymptomById(row.id, this.endRemoveTime);
      if (res.code == 0) {
        this.$message.success("移除成功");
        row.removeVisible = false;
        this.getPageSymptom();
      }
    },
    // 编辑症状
    editSeverity(row) {
      this.editSeverityLoading = true;
      if (!this.levelId) {
        this.$message("请选择症状程度");
        return false;
      }
      editSymptomSeverity({
        id: row.id,
        levelId: this.levelId
      })
        .then(res => {
          if (res.code == 0) {
            this.$message.success("症状编辑成功");
            this.levelId = "";
            this.editSeverityLoading = false;
            row.editVisible = false;
            this.getPageSymptom();
          }
        })
        .catch(err => {
          this.editSeverityLoading = false;
        });
    },
    cancelSeverity(row) {
      this.levelId = "";
      this.editSeverityLoading = false;
      row.editVisible = false;
    },
    handleAdd(row) {
      this.showAddStatus = true;
      this.selectRow = row;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.activeName == "second") {
        this.getPageSymptom();
      }
      if (this.activeName == "third") {
        this.getPatientSavePage();
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.activeName == "second") {
        this.getPageSymptom();
      }
      if (this.activeName == "third") {
        this.getPatientSavePage();
      }
    },
    changeQueryTime() {
      if (!this.searchQueryObj.searchQueryTime) {
        this.searchQueryObj.searchQueryTime = [];
        this.$set(this.searchQueryObj, "searchQueryTime", [
          moment()
            .subtract(3, "months")
            .format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD")
        ]);
      }
    },
    // 通过患者id差当前病种和治疗阶段
    async getDiseaseIdTherapyStage() {
      let { code, data } = await getArchiveDiseaseAndTherapyStage({
        patientId: this.$store.state.patientInfo.patientId
      });
      if (code === 0) {
        this.diseaseAndTherapyStage = data;
      }
    },
    // 完整病程
    async getPageCourse(flag) {
      if (flag == 1) {
        this.current = 1;
      }
      let res = await pageCourseNew({
        startTime: this.searchQueryObj.searchQueryTime[0],
        endTime: this.searchQueryObj.searchQueryTime[1],
        current: this.current,
        size: 20,
        patientId: this.$store.state.patientInfo.patientId,
        name: this.searchQueryObj.name
      });
      if (res.code == 0) {
        this.allCourseData = res.data.records.map(item => {
          return {
            ...item,
            records: item.records.map(items => {
              return {
                ...items,
                patientSymptomVOListString:
                  items.patientSymptomVOList &&
                  items.patientSymptomVOList.length > 0
                    ? items.patientSymptomVOList
                        .map(itemss => itemss.name)
                        .join(",")
                    : "",
                checkInfoString:
                  items.checkInfo && items.checkInfo.length > 0
                    ? items.checkInfo.map(itemss => itemss.name).join(",")
                    : "",
                inspectionInfoString:
                  items.inspectionInfo && items.inspectionInfo.length > 0
                    ? items.inspectionInfo.map(itemss => itemss.name).join(",")
                    : ""
              };
            })
          };
        });
        let arrCourse = [];
        arrCourse = res.data.records.map(v => v.patientSymptomVOList);
        if (!res.data.records.length || arrCourse.length < 20) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      }
    },
    // 完整病程=生化指标
    async getAnomalyHistory(flag) {
      if (flag == 1) {
        this.current = 1;
        this.anomalyData = [];
      }
      this.loading = false;
      let res = await anomalyHistory({
        startTime: this.hisToryObj.time ? this.hisToryObj.time[0] : "",
        endTime: this.hisToryObj.time ? this.hisToryObj.time[1] : "",
        current: this.current,
        size: 20,
        patientId: this.$store.state.patientInfo.patientId,
        nameLike: this.hisToryObj.nameLike
      });
      if (res.code == 0) {
        this.anomalyData = this.anomalyData.concat(res.data.records);
        if (!res.data.records.length || this.anomalyData.length < 20) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      }
    },
    // 当前症状
    async getPageSymptom() {
      let res = await pageSymptom({
        current: this.currentPage,
        size: this.pageSize,
        patientId: this.$store.state.patientInfo.patientId,
        startTime: moment().format("YYYY-MM-DD"),
        ended: false,
        diseaseId: this.diseaseAndTherapyStage.diseaseId,
        firstTherapyStageId: this.diseaseAndTherapyStage.firstTherapyStageId,
        secondTherapyStageId: this.diseaseAndTherapyStage.secondTherapyStageId
      });
      if (res.code == 0) {
        res.data.records.map(v => {
          v.removeVisible = false;
          v.editVisible = false;
        });
        this.nowSymptomData = res.data.records;
        this.totalNum = res.data.total;
      }
    },
    // 患者提交症状
    async getPatientSavePage() {
      let res = await patientSavePage({
        startTime: moment()
          .subtract(3, "months")
          .format("YYYY-MM-DD"),
        endTime: moment().format("YYYY-MM-DD"),
        current: this.currentPage,
        size: this.pageSize,
        patientId: this.$store.state.patientInfo.patientId
      });
      if (res.code == 0) {
        this.patientSymptomData = res.data.records;
        this.totalNum = res.data.total;
      }
    },
    addDiseaseRecord() {
      this.selectRecordItem = {};
      this.showAddRecord = true;
    },
    handleTabClick() {
      this.currentPage = 1;
      this.pageSize = 10;
      if (this.activeName == "first") {
        this.current = 1;
        this.allData = [];
        this.allCourseData = [];
        this.getPageCourse();
      }
      if (this.activeName == "second") {
        this.getPageSymptom();
      }
      if (this.activeName == "third") {
        this.getPatientSavePage();
      }
    },
    // 获取当前症状的程度id
    async getSymptomLevelList(row) {
      this.levelId = row.levelId;
      let { code, data } = await pageSymptomLevelList({
        symptomId: row.symptomId,
        diseaseId: row.diseaseId,
        firstTherapyStageId: row.firstTherapyStageId,
        secondTherapyStageId: row.secondTherapyStageId
      });
      if (code === 0) {
        this.symptomGradingOption = data;
      }
    }
  }
};
</script>

<style lang="less">
@import "./taskReminder.less";
.crossreference-tabs {
  position: relative;
  .el-tabs__header {
    margin-bottom: 0;
  }
  .el-tabs__item {
    font-size: 12px;
  }
  .el-tabs__nav-wrap::after {
    height: 0px !important;
  }
}
.symptom-table-pop {
  .el-popconfirm__main {
    width: 180px;
  }
  .el-popconfirm__action {
    margin-top: 10px;
  }
}
.remove-pop {
  padding: 25px;
  .remove-tips {
    font-size: 14px;
    color: #333333;
    line-height: 14px;
    margin-bottom: 20px;
    span:nth-child(1) {
      width: 106px;
    }
  }
}
</style>
<style lang="less" scoped>
.no-data {
  font-size: 12px;
  color: rgb(204, 204, 204);
  text-align: center;
  margin: 15px 0;
}
.empty-img {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.type-title {
  display: flex;
  justify-content: space-between;
  padding: 22px 24px 5px;
  .tab-box {
    width: 180px;
    height: 32px;
    background: #edf0f2;
    border-radius: 2px;
    padding: 2px;
    display: flex;
    align-items: center;
    cursor: pointer;
    div {
      width: 88px;
      border-radius: 2px;
      text-align: center;
      line-height: 28px;
      font-weight: bold;
    }
    .checked {
      background: #ffffff;
      color: #1a7bfc;
    }
  }
  p {
    color: #1a7bfc;
    font-weight: bold;
    line-height: 28px;
    cursor: pointer;
  }
}
.symptom-result {
  display: flex;
  height: 16px;
  p {
    font-size: 14px;
    margin-right: 10px;
    font-weight: bold;
    max-width: 235px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .result-type {
    width: 60px;
    height: 20px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #e7f6f0;
    color: #3ab683;
    span {
      margin-left: 6px;
    }
    i {
      font-size: 14px;
    }
  }
  .abnormal {
    background: #ffefeb;
    color: #ff7255;
  }
}
.reuslt-range {
  color: #666;
}
.push-title /deep/.el-drawer__header {
  font-size: 22px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin: 20px 0 !important;
  padding-right: 20px !important;
}
.record-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px 0 17px;
  height: 44px;
  background: #e9f6ff;
  p {
    font-size: 14px;
    color: #1a7bfc;
  }
  span {
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
  .date-icon {
    display: flex;
    align-items: center;
    img {
      width: 32px;
      margin-right: 5px;
    }
  }
}
.symptom-flex {
  display: flex;
  flex-wrap: wrap;
  div {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    margin-right: 30px;
  }
  .no-checked-mark {
    width: 16px;
    height: 16px;
    background: #f5f8fe;
    border-radius: 3px;
    border: 1px solid #cccccc;
    margin: 0 8px 0 0;
  }
}
.symptom-item {
  img {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
}
.symptom-item-box {
  padding: 20px 40px 5px;
}
.symptom-item p {
  font-size: 14px;
  margin-bottom: 20px;
}

/deep/.el-date-editor .el-range-separator {
  width: 30px;
}
.red-tag {
  display: block;
  width: 8px;
  height: 8px;
  background: #f14352;
  border-radius: 7px;
  position: absolute;
  top: 18px;
  left: 270px;
}
.through-del {
  text-decoration: line-through;
}
.search-line {
  margin-bottom: 20px;
}
.refeFileName-top {
  img {
    width: 20px;
    height: 20px;
    vertical-align: middle;
  }
}
.footer-pagination {
  text-align: right;
  margin-top: 20px;
  padding-right: 20px;
}
.patient-line-symptom-all {
  margin-top: -22px;
}
.patient-line-symptom {
  padding-left: 18px !important;
  padding-right: 16px;
  li {
    background: #f8f8f8;
    padding: 6px 16px;
  }
  .symptom-row {
    border-bottom: 1px solid #eeeeee;
    padding-top: 8px;
    &:first-child {
      padding-top: 0;
    }
    .symptom-row-title {
      display: flex;
      justify-content: space-between;
      .time {
        font-weight: bolder;
        font-size: 14px;
        &.update {
          color: #1a7bfc;
        }
        &.delete {
          color: #fb5555;
        }
      }
    }
    div {
      margin-bottom: 12px;
    }
  }
  .symptom-row:last-child {
    border-bottom: none;
  }
  .symptom-name {
    font-size: 12px;
    font-weight: 700;
    color: #333333;
    margin-right: 10px;
    display: inline-block;
  }
  .ing-status,
  .end-status {
    width: 52px;
    height: 24px;
    border-radius: 2px;
    border: 1px solid #1a7bfc;
    text-align: center;
    line-height: 24px;

    font-size: 12px;
    font-weight: 500;
    color: #1a7bfc;
    cursor: pointer;
    padding: 1px 2px;
  }
  .end-status {
    border: 1px solid #999999;
    color: #999999;
  }
}
.anomaly li {
  margin-bottom: 20px;
}
.symptom-table-data {
  padding: 0 24px;
}
.courseInfo-row {
  display: flex;
  justify-content: flex-end;
  .update-btn {
    font-size: 12px;
    font-weight: 600;
    color: #1a7bfc;
    cursor: pointer;
  }
  .delete-btn {
    font-size: 12px;
    font-weight: 600;
    color: #fb5555;
    cursor: pointer;
    margin-left: 20px;
  }
}

.all-course {
  width: 20px;
  display: flex;
  justify-content: space-between;
  position: relative;
  top: 11px;
  .record-folder-time {
    display: flex;
    color: #333333;
    .source {
      display: flex;
      margin-left: 16px;
      img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
    }
  }
}
</style>